export default function inArray(value, array) {
    if (array) {
        return array.includes(value);
    }
}